/* eslint-disable import/no-unused-modules */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'modules-expertDirectory-title' },
  subtitle: { id: 'modules-expertDirectory-subtitle' },
  resultsTitle: { id: 'modules-expertDirectory-resultsTitle' },
  resultsPageDescription: { id: 'modules-expertDirectory-resultsPageDescription' },
  redirectionCta: { id: 'modules-expertDirectory-redirectionCta' },
  adjustSearch: { id: 'modules-expertDirectory-adjustSearch' },
  hoverAdjustSearch: { id: 'modules-expertDirectory-hoverAdjustSearch' },
  hoverSerpModalCta: { id: 'modules-expertDirectory-hoverSerpModalCta' },
  bannerTitle: { id: 'modules-expertDirectory-bannerTitle' },
  bannerDesc: { id: 'modules-expertDirectory-bannerDescription' },
  bannerHoverTitle: { id: 'modules-expertDirectory-bannerHoverTitle' },
});

export default messages;
